<template>
  <div class="projectGZJD">
    <el-tabs type="border-card" v-model="activeName" @tab-click="tabChange">
      <el-tab-pane
        v-for="item in ruleList"
        :key="item.nodeId"
        :label="item.title"
        :name="item.nodeId"
      ></el-tab-pane>
    </el-tabs>
    <div class="projectGZJD-choose">
      <el-checkbox
        v-for="item in chooseItem.childList"
        :key="item.subNodeId"
        :label="item.subNodeId"
        :checked="item.subNodeResult == 1 ? true : false"
        @change="(v) => changeNode(v, item)"
        >{{ item.subNodeTitle }}</el-checkbox
      >
    </div>
    <div class="projectGZJD-main">
      <el-row :gutter="10">
        <el-col :span="8">
          <!-- <div style="">1</div> -->
          <div class="projectGZJD-main-log" style="min-height: 20px;">
            <el-timeline-item
              v-for="log in chooseItem.logList"
              :key="log.id"
              :timestamp="log.operatorTime"
            >
              {{ log.content }}
            </el-timeline-item>
          </div>
        </el-col>
        <el-col :span="16">
          <div
            v-for="item in chooseItem.fileNodeDTOList"
            :key="item.fileNodeId"
            style="margin-bottom: 16px"
          >
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="18">
                <h3>
                  {{ item.fileNodeTitle }}
                </h3>
              </el-col>
              <el-col :span="6">
                <el-upload
                  action="/KYWB/foreign/storage/uploadFile"
                  :headers="headersObj"
                  :file-list="liveImageFileList"
                  :on-preview="handlePictureCardPreview"
                  :on-success="handleSuccess"
                >
                  <el-button
                    size="small"
                    type="primary"
                    @click="clickOneUpload(item)"
                    >上传附件</el-button
                  >
                </el-upload>
              </el-col>
            </el-row>
            <div v-if="item.filePathList" style="margin-top: 16px">
              <el-table
                :data="item.filePathList"
                border
                size="small"
                style="width: 100%"
              >
                <el-table-column
                  prop="filePath"
                  label="附件"
                  width="200"
                  :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column label=""></el-table-column>
                <el-table-column fixed="right" label="操作" width="70">
                  <template slot-scope="scope">
                    <el-button
                      @click="handleDel(scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  getProjectTrack,
  addTrackFile,
  saveTrackItem,
  deleteTrackFile,
} from "@/api/salesManagement/detail";
import cookies from "@/libs/util.cookies";
export default {
  name: "ProjectGZJD",
  props: ["projectId"],
  data() {
    return {
      chooseItem: {},
      ruleList: [],
      activeName: null,
      checkList: [],
      headersObj: {
        Authorization: "Bearer " + cookies.get("token"),
        appCode: "YHGHT",
      },
      liveImageFileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  created() {
    this.getProjectTrackFun();
  },
  methods: {
    clickOneUpload(item) {
      this.fileNode = item;
    },
    handleSuccess(res) {
      if (res && res.data) {
        this.addTrackFileFun(res.data.url);
      }
    },
    async addTrackFileFun(filePath) {
      const res = await addTrackFile({
        projectId: this.projectId,
        filePath,
        fileNodeId: this.fileNode.fileNodeId,
        nodeId: this.chooseItem.nodeId,
      });
      if (res.code === 200) {
        this.getProjectTrackFun(true);
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    async getProjectTrackFun(need = false) {
      const res = await getProjectTrack(this.projectId);
      if (
        res.code === 200 &&
        res.data &&
        res.data.content &&
        res.data.content.length
      ) {
        this.ruleList = res.data.content;
        if (!need) {
          this.chooseItem = res.data.content[0];
          this.activeName = res.data.content[0].nodeId;
          return;
        }
        const item = res.data.content.find(
          (item) => item.nodeId === this.activeName
        );
        if (item) {
          this.chooseItem = item;
        }
      }
    },
    tabChange(v) {
      const item = this.ruleList.find(
        (item) => item.nodeId === this.activeName
      );
      if (item) {
        this.chooseItem = item;
      }
    },
    async handleDel(row) {
      await deleteTrackFile(row);
      this.getProjectTrackFun(true);
    },
    changeNode(row, item) {
      const data = {
        subNodeId: item.subNodeId,
        subNodeResult: row ? 1 : 0,
        projectId: this.projectId,
        nodeId: this.chooseItem.nodeId,
      };
      item.subNodeResult = row ? 1 : 0;
      saveTrackItem(data);
    },
  },
};
</script>

<style scoped lang="scss">
.projectGZJD {
  &-choose,
  &-main {
    margin-top: 16px;
  }
  .el-upload-list {
    display: none;
  }
  .el-timeline-item {
    list-style-type: none;
  }
}
</style>
<style lang="scss">
.projectGZJD {
  .el-upload-list {
    display: none;
  }
  &-main {
    &-log {
      max-height: 400px;
      overflow: auto;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/salesManagement/xmgl/components/DetailProoject/gzjd.vue